module.exports = __webpack_public_path__ + "img/usesc.7dee8f51.png";